
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"action.label":"GPX file ...","action.tooltip.disabled":"The date attribute for the connection order is missing in the “Data” tab.","dialog.title":"Export GPX file"},"de":{"action.label":"GPX-Datei ...","action.tooltip.disabled":"Es fehlt im Register \"Daten\" das Datumsattribut für die Verbindungsreihenfolge.","dialog.title":"GPX-Datei exportieren"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();